import OemActionIcons from "./OemActionIcon";
export const getHeaderConfig = (loadData) => [
  {
    label: "Code",
    id: "code",
  },
  {
    label: "Name",
    id: "name",
  },
  {
    label: "Email",
    id: "email",
  },
  {
    label: "Address",
    id: "address",
    render: (data) => {
      return data?.address?.line1;
    },
  },
  {
    label: "Actions",
    id: "actions",
    render: (data) => {
      return (
        <OemActionIcons
          id={data.id}
          data={data}
          LoadData={loadData}
          Code={data.code}
          Name={data.name}
          Address={data.address}
          Industry={data.industry}
          admin={data.admin}
          Email={data.email}
          phoneNo={data?.phoneNumber}
        />
      );
    },
  },
];
export const getMobileHeaderConfig = (loadData) => [
  {
    label: "Name",
    id: "name",
  },
  {
    label: "Email",
    id: "email",
  },
  {
    label: "Actions",
    id: "actions",
    render: (data) => {
      return (
        <OemActionIcons
          id={data.id}
          LoadData={loadData}
          Code={data.code}
          Name={data.name}
          Address={data.address}
          Industry={data.industry}
          admin={data.admin}
        />
      );
    },
  },
];
